import React from 'react';

import styles from './Consent.module.css';

const Consent = () => (
  <div className="boxed-container">
    <h2>
      We have updated our User Information Notice
    </h2>

    <div className={styles.contract}>
      <p>We take data protection very seriously. And it as a great opportunity to show you exactly what we do with the information you give us permission to have.</p>
      <p>The Data Protection Regulation allows you to have more control over what happens to your information too.</p>
      <p>Our new <a href="https://login.sierrawireless.io/user-notice" target="_blank" rel="noopener noreferrer">User Information Notice</a> will tell you exactly what information we collect, how we collect it, how we can use it for, and how can you manage your personal data.</p>
    </div>

    <div className="margin-top-large">
      <form target="_self" method="post" action={`/session/consent${window.location.search}`}>
        <div className="margin-top-large">
          <button className="btn" name="gdprConsent" value="true">
            ACCEPT
          </button>
        </div>
      </form>
    </div>
  </div>
);

export default Consent;
